export default __webpack_public_path__ + "static/media/taart_icon.7b389d03.png";